import React from "react";
import { FiX } from "react-icons/fi";

const InfluencerFormModal = ({
  formData,
  setFormData,
  onSubmit,
  onClose,
  editing
}) => {

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else if (name === "platform") {
      const platforms = value
        .split(",")
        .map(p => p.trim())
        .filter(Boolean);

      setFormData(prev => ({ ...prev, platform: platforms }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto shadow-xl">

        {/* HEADER */}
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
          <h2 className="text-xl font-semibold">
            {editing ? "Edit Influencer" : "Add Influencer"}
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <FiX size={22} />
          </button>
        </div>

        {/* FORM */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          className="p-6 space-y-6"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* Username */}
            <Input label="Username *" name="username" value={formData.username} onChange={handleChange} required />

            {/* Name */}
            <Input label="Name" name="name" value={formData.name} onChange={handleChange} />

            {/* Email */}
            <Input label="Email" name="email" type="email" value={formData.email} onChange={handleChange}/>

            {/* Mobile */}
            <Input label="Mobile" name="mobile" value={formData.mobile} onChange={handleChange} />

            {/* Title */}
            <Input label="Title" name="title" value={formData.title} onChange={handleChange} />

            {/* Rating */}
            <Input label="Rating" name="rating" type="number" min="0" max="5" step="0.1" value={formData.rating} onChange={handleChange} />

            {/* Price */}
            <Input label="Price" name="price" type="number" min="0" step="0.01" value={formData.price} onChange={handleChange} />

            {/* Followers */}
            <Input label="Followers" name="followers" type="number" min="0" value={formData.followers} onChange={handleChange} />

            {/* Following */}
            <Input label="Following" name="following" type="number" min="0" value={formData.following} onChange={handleChange} />

            {/* Posts */}
            <Input label="Posts" name="posts" type="number" min="0" value={formData.posts} onChange={handleChange} />

            {/* Review Count */}
            <Input label="Review Count" name="reviewCount" type="number" min="0" value={formData.reviewCount} onChange={handleChange} />

            {/* Platform */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Platform (comma-separated)
              </label>
              <input
                type="text"
                name="platform"
                value={Array.isArray(formData.platform) ? formData.platform.join(", ") : ""}
                onChange={handleChange}
                placeholder="Instagram, YouTube"
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500"
              />
            </div>

            {/* Category */}
            <Input label="Category" name="category" value={formData.category} onChange={handleChange} />

            {/* Location */}
            <Input label="Location" name="location" value={formData.location} onChange={handleChange} />

            {/* Gender */}
            <div>
              <label className="block text-sm font-medium mb-1">Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500"
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* Age */}
            <Input label="Age" name="age" type="number" min="0" value={formData.age} onChange={handleChange} />

            {/* Language */}
            <Input label="Language" name="language" value={formData.language} onChange={handleChange} />

            {/* Image */}
            <Input label="Image URL" name="image" type="url" value={formData.image} onChange={handleChange} />

            {/* Avatar */}
            <Input label="Avatar URL" name="avatar" type="url" value={formData.avatar} onChange={handleChange} />

            {/* Content Type */}
            <Input label="Content Type" name="contentType" value={formData.contentType} onChange={handleChange} />

            {/* Active */}
            <Checkbox label="Active" name="isActive" checked={formData.isActive} onChange={handleChange} />

          </div>

          {/* Bio */}
          <div>
            <label className="block text-sm font-medium mb-1">Bio</label>
            <textarea
              name="bio"
              value={formData.bio}
              onChange={handleChange}
              rows="4"
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500"
            />
          </div>

          {/* FOOTER */}
          <div className="flex justify-end gap-4 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 border rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700"
            >
              {editing ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default React.memo(InfluencerFormModal);



/* ---------------- Reusable Components ---------------- */

const Input = ({ label, ...props }) => (
  <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    <input
      {...props}
      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500"
    />
  </div>
);

const Checkbox = ({ label, name, checked, onChange }) => (
  <div className="flex items-center mt-6">
    <input
      type="checkbox"
      name={name}
      checked={checked}
      onChange={onChange}
      className="h-4 w-4 text-orange-600"
    />
    <label className="ml-2 text-sm">{label}</label>
  </div>
);
